/**
 * Theme: focus rings on POINTER interaction, store-wide.
 *
 * THE PROBLEM CSS CANNOT SOLVE ALONE.
 * `:focus-visible` reflects the CURRENT input modality, not how the element was
 * reached. Escape is a keypress, so the instant a <dialog> hands focus back,
 * Chrome reports "keyboard" and paints a ring, for a shopper who has touched
 * nothing but the mouse. No `:focus:not(:focus-visible)` rule can catch that,
 * because the element genuinely IS focus-visible.
 *
 * THE MECHANISM. One attribute on <html> records the last input the shopper
 * used to NAVIGATE, and CSS keys off it:
 *
 *   data-ats-input="pointer"  no rings on buttons, links, summaries, [tabindex]
 *   data-ats-input="key"      normal focus indicators everywhere
 *
 * ONLY TAB FLIPS TO KEYBOARD MODE. Tab is the key that moves focus BETWEEN
 * controls, which is the moment a focus ring starts earning its keep. Other keys
 * do not:
 *
 *   Escape       a command. It closes a drawer or the lightbox and hands focus
 *                back; treating it as navigation was the original bug here.
 *   Arrow keys   navigate WITHIN a widget, not between controls. In the lightbox
 *                they step through images while focus sits on the close button,
 *                so flipping on them lit up a control the shopper was not aiming
 *                at, and left the store in keyboard mode so the tile focused on
 *                close lit up too. Both rings came from this one line.
 *   Enter/Space  activate the focused control; they do not move focus.
 *
 * A keyboard user always reaches a composite widget by tabbing to it first, so
 * mode is already 'key' before any arrow is pressed and nothing is lost.
 *
 * NO ATTRIBUTE IS SET UNTIL THE FIRST INTERACTION, so the default state is
 * Horizon's own behaviour and nothing is suppressed speculatively.
 *
 * Text fields are excluded in CSS, not here: a caret with no focus styling is
 * confusing regardless of how the field was reached.
 */
(function () {
  var root = document.documentElement;

  document.addEventListener(
    'pointerdown',
    function () {
      root.setAttribute('data-core-input', 'pointer');
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Tab') return;
      root.setAttribute('data-core-input', 'key');
    },
    true
  );
})();
